import { Box, Table, TableContainer } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { getOtpByExternalId, OtpType } from '@nemuru-eng/js-api-client';

import { DetailsDataSkeleton } from '@/components/modules/AssetDetails/components/shared/DetailsDataSkeleton';
import { OtpTableBody } from '@/components/modules/KYC/KYCOrder/components/Otp/components/OtpTableBody';
import { OtpTableHeader } from '@/components/modules/KYC/KYCOrder/components/Otp/components/OtpTableHeader';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Font } from '@/components/shared/components/Font';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useScreen } from '@/hooks/useScreen';

interface OtpProps {
  loanId: string;
  loading: boolean;
}

export const Otp = ({ loanId, loading }: OtpProps) => {
  const { isMobile } = useScreen();

  const { data: otp } = useCache(getOtpByExternalId, { loanId, otpType: OtpType.LOAN_ONBOARDING });

  if (!otp && !loading) return <PendingDataWarning />;

  return (
    <SubSectionWrapper title={isMobile ? 'PHONE_VERIFICATION_SHORT' : 'PHONE_VERIFICATION'}>
      <Box pt={2}>
        {!otp ? (
          <DetailsDataSkeleton numberOfRows={4} pt={3} />
        ) : (
          <FormGridContainer>
            <TextFormField name={'otp_status'} label={'OTP_STATUS'} value={<Text tId={otp.status} />} />
            <TextFormField name={'phone_number'} label={'PHONE_NUMBER'} value={otp.recipient} />

            <TextFormField name={'received_code'} label={'RECEIVED_CODE'} value={otp.receivedCode} />
            <TextFormField
              name={'received_code_date'}
              label={'RECEIVED_CODE_DATE'}
              value={
                otp.receivedCodeDate
                  ? `${otp.receivedCodeDate.toLocaleDateString()} ${otp.receivedCodeDate.toLocaleTimeString()}`
                  : undefined
              }
            />
          </FormGridContainer>
        )}
        <Box mt={3} />
        <Font variant={'h4'} color={'textSecondary'}>
          <Text tId={'SENT_CODES'} />
        </Font>
        <Box mt={2} />
        {!otp ? (
          <Skeleton height={'82px'} width={'100%'} />
        ) : (
          <TableContainer id={'table-container'}>
            <Table>
              <OtpTableHeader />
              <OtpTableBody sentCodesToRecipient={otp.sentCodesToRecipient} />
            </Table>
          </TableContainer>
        )}
      </Box>
    </SubSectionWrapper>
  );
};
